import React from 'react'
import SubmitButton from 'components/common/submitButton'
import clsx from 'clsx'
import { useStyles } from './styles.css'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    useMediaQuery,
    useTheme,
} from '@material-ui/core'
import { Trans } from 'react-i18next'
import DetailsForm, { DetailsFormState } from 'components/forms/establishment/detailsForm'
import { EstablishmentType } from '@sugg-gestion/ubidreams-react-suggpro'
import CloseButton from 'components/dialogs/closeButton'
import { CountryCode } from 'libphonenumber-js/types'

interface Props {
    open: boolean
    onClose: () => void
    onSubmit: (values: DetailsFormState) => void
    inProgress: boolean
    initialValues: DetailsFormState
    establishmentTypes?: Array<EstablishmentType>
    typeMandatory: boolean
    type: 'duns' | 'europeanVat'
    country: CountryCode
}

const EstablishmentDetailsDialogView: React.FC<Props> = ({ open, onClose, inProgress, ...formData }) => {
    const classes = useStyles()

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('xs'))

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={fullScreen}
            scroll="paper"
            classes={{
                paper: classes.paper,
            }}
            maxWidth="md"
        >
            <DetailsForm formClassName={classes.form} inProgress={inProgress} {...formData}>
                {(content, actions) => (
                    <>
                        <DialogTitle>
                            <Trans i18nKey="views.establishment.details.title" />
                        </DialogTitle>
                        <DialogContent dividers>
                            <CloseButton onClose={onClose} />
                            {content}
                        </DialogContent>
                        <DialogActions className={classes.actions}>
                            <Button variant="contained" onClick={onClose}>
                                <Trans i18nKey="actions.cancel" />
                            </Button>
                            {actions.map((action, index) => (
                                <SubmitButton
                                    key={index}
                                    variant="contained"
                                    color="primary"
                                    {...action}
                                    className={clsx(action.className)}
                                >
                                    <Trans i18nKey="actions.validate" />
                                </SubmitButton>
                            ))}
                        </DialogActions>
                    </>
                )}
            </DetailsForm>
        </Dialog>
    )
}

export default EstablishmentDetailsDialogView
